export const apiServer = chooseEnviroment(process.env.REACT_APP_HOST_ENV)
export const gromartServer = chooseEnviromentGromart(process.env.REACT_APP_HOST_ENV)

function chooseEnviroment(enviroment) {
  const defaultNextokenServer = "http://10.10.3.114:2000";
  if (enviroment === "localstaging") {
    return defaultNextokenServer;
  }
  if (enviroment === "staging") {
    return "https://staging-token.nexcloud.id";
  }
  if (enviroment === "sandbox") {
    return "";
  }
  if (enviroment === "production") {
    return "";
  }
  return defaultNextokenServer;
}

function chooseEnviromentGromart(enviroment) {
  const defaultGromartServer = "https://staging.gromart.club:7443/marketplace";
  if (enviroment === "localstaging") {
    return defaultGromartServer;
  }
  if (enviroment === "staging") {
    return defaultGromartServer;
  }
  if (enviroment === "sandbox") {
    return "https://sandbox.gromart.club:8443/marketplace";
  }
  if (enviroment === "production") {
    return "https://www.gromart.club/marketplace";
  }
  return defaultGromartServer;
}